<template>
	<div>
		<h3>Loading</h3>
		<b-spinner label="Spinning"></b-spinner>
	</div>
</template>
<script>

export default {
	name: "Loading"
}

</script>
